import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';

interface IQuestionPlaceModal {
  open: boolean;
  onClose: () => void;
  onConfirm: (value: string) => void;
}

const QuestionPlacementModal: React.FC<IQuestionPlaceModal> = ({
  open,
  onClose,
  onConfirm,
}) => {
  // State
  const [value, setValue] = useState('after');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };

  return (
    <div>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Choose Placement for Question</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Select where you’d like to place the question within this subtopic.
          </DialogContentText>
          <FormControl style={{ margin: '20px' }}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              value={value}
              onChange={handleChange}
            >
              <FormControlLabel
                value="before"
                control={<Radio />}
                label="Before this slide"
              />
              <FormControlLabel
                value="after"
                control={<Radio />}
                label="After this slide"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions style={{ padding: '20px' }}>
          <Button color="inherit" variant="contained" onClick={onClose}>
            Dismiss
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => onConfirm(value)}
          >
            Insert
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default QuestionPlacementModal;
